import { MetricPanelProps } from "../../services/types";
import { getSortedMetrics, getSvgrMap } from "../../utils/dashboardUtils";
import MetricCard from "../MetricCard";
import SoloIcon from "../SoloIcon";
import GradientBar from "../GradientBar";
import { useDashboardColor } from "../../context/DashboardColorContext";
import MetricStatValue from "../charts/MetricStatValue";

const HousingMetrics = ({ categorizedData, indicators, tab, geoDetails, geoTag }: MetricPanelProps) => {       
    const color = useDashboardColor();
    const sortedMetrics = getSortedMetrics(tab, categorizedData);
    const h = sortedMetrics[0];
    const workHrs = indicators.find((i: any) => i.id === 1107);
    const renterCostBurden = indicators.find((i: any) => i.id === 1074);
    const ownerCostBurden = indicators.find((i: any) => i.id === 1071);

    return (
        <div className="h-screen">
        <p className="text-xs text-neutral-600 mx-6 pt-2">
            Activate the <span aria-hidden="true">🛈</span> <strong>button</strong> to expand additional information about a metric.
        </p>
        <div className="mx-auto px-4 pb-8 pt-2">
            <div className="grid grid-cols-1 xxs:grid-cols-2 xs:grid-cols-3 gap-4">
                {h.map((metric: any) => (
                    <MetricCard
                        key={metric.id}
                        metric={metric}   
                        svg={getSvgrMap(metric.id)}
                        disaggData={indicators}
                        geoDetails={geoDetails}
                        geoTag={geoTag}
                    />
                ))}

                <div className="col-span-1 xxs:col-span-2 xs:col-span-3 w-full">
                    <div 
                        className="relative overflow-hidden group hover:shadow-md transition-all border rounded-xl bg-white" 
                    >
                        <div className="bg-white p-3">
                            <h3 className="text-sm font-semibold text-color-cai-brown">
                                Housing Affordability
                            </h3>
                            
                            <div className="grid grid-cols-1 xxs:grid-cols-3 gap-2">
                                <div className="flex flex-col items-center mt-2">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1074}
                                            id={1074}
                                            unit={renterCostBurden?.versions[0].unit}
                                            title={renterCostBurden?.name ?? "Cost-Burdened Renters"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={renterCostBurden}/>
                                </div> 
                                <div className="flex flex-col items-center mt-2">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1071}
                                            id={1071}
                                            unit={ownerCostBurden?.versions[0].unit}
                                            title={ownerCostBurden?.name ?? "Cost-Burdened Homeowners"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={ownerCostBurden}/>
                                </div>
                                <div className="flex flex-col items-center mt-2">
                                    <div className="ml-20">
                                        <SoloIcon
                                            key={1107}
                                            id={1107}
                                            unit={workHrs?.versions[0].unit}
                                            title={workHrs?.name ?? "Cost-Burdened Renters"}
                                            svg={undefined}
                                            disaggData={indicators}
                                            geoDetails={geoDetails}
                                            geoTag={geoTag}
                                        />
                                    </div>
                                    <MetricStatValue metric={workHrs}/>
                                </div> 
                            </div>
                        </div>
                        <GradientBar color={color} />
                    </div>
                </div>
            </div>
        </div>
        </div>
    );
}

export default HousingMetrics;